module.exports = __webpack_public_path__ + "02_medium_gold.c70e756d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_medium_gold.png
// module id = 7ddA
// module chunks = 0